(() => {
  const getPageType = () => document.body?.getAttribute("data-page-type") || null;

  const emit = (name, detail) => {
    if (!name) return;

    try {
      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push({ event: name, ...detail });
      }
    } catch (_) {}

    try {
      document.dispatchEvent(new CustomEvent("sumolink:event", { detail: { name, ...detail } }));
    } catch (_) {}
  };

  document.addEventListener(
    "click",
    (event) => {
      const target = event.target instanceof Element ? event.target.closest("[data-sumolink-event]") : null;
      if (!target) return;

      emit(target.getAttribute("data-sumolink-event"), {
        href: target.getAttribute("href"),
        page_type: getPageType(),
      });
    },
    { capture: true }
  );
})();
